import { render, staticRenderFns } from "./ProviderPromotionsForm.vue?vue&type=template&id=141fea26&scoped=true&"
import script from "./ProviderPromotionsForm.vue?vue&type=script&lang=js&"
export * from "./ProviderPromotionsForm.vue?vue&type=script&lang=js&"
import style0 from "./ProviderPromotionsForm.vue?vue&type=style&index=0&id=141fea26&scoped=true&lang=css&"
import style1 from "./ProviderPromotionsForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141fea26",
  null
  
)

export default component.exports